import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { usePlayerFields } from 'js/hooks/usePlayerFields';
import { useFetchParams } from 'js/hooks/user/hooks/useFetchUserDetails';

import * as server from 'js/hooks/user/server';
import * as actions from 'js/hooks/user/store/actions';
import { parseUserDetails } from 'js/hooks/user/helpers';

export * from 'js/hooks/user/hooks/useFetchUserDetails';

// TODO: core file, added check state, when we clear 'state' then IMS does not return empty state
export const useFetchUserDetails = () => {
    const dispatch = useDispatch();
    const { networkTypes, networkDataFilters } = useFetchParams();
    const defaultPlayerFields = usePlayerFields();

    return useCallback(async (playerFields = []) => {
        const fields = playerFields.length ? playerFields : defaultPlayerFields;
        const response = await server.fetchUserDetails(fields, networkTypes, networkDataFilters);
        const data = parseUserDetails(response.data);

        if (typeof data.state === 'undefined' && fields.includes(29)) {
            data.state = '';
        }

        dispatch(actions.setDetails(data));

        return data;
    }, [networkTypes, networkDataFilters, dispatch, defaultPlayerFields]);
};
